import { render, staticRenderFns } from "./GastosReembolsablesDetail.vue?vue&type=template&id=1e595255&scoped=true&"
import script from "./GastosReembolsablesDetail.vue?vue&type=script&lang=js&"
export * from "./GastosReembolsablesDetail.vue?vue&type=script&lang=js&"
import style0 from "./GastosReembolsablesDetail.vue?vue&type=style&index=0&id=1e595255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e595255",
  null
  
)

export default component.exports